/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type MonerisProvider_configuration = {
    readonly currency: string;
    readonly organisationContact: string;
    readonly monerisHostedTokenization: {
        readonly uri: string | null;
        readonly profileId: string | null;
    } | null;
    readonly " $refType": "MonerisProvider_configuration";
};
export type MonerisProvider_configuration$data = MonerisProvider_configuration;
export type MonerisProvider_configuration$key = {
    readonly " $data"?: MonerisProvider_configuration$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"MonerisProvider_configuration">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MonerisProvider_configuration",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationContact",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "MonerisHostedTokenization",
            "kind": "LinkedField",
            "name": "monerisHostedTokenization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uri",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Configuration",
    "abstractKey": null
} as any;
(node as any).hash = '239e6b435b5e20ddc16751b2bc163a3d';
export default node;
